import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// YouTube searches go through our Django proxy (/api/v1/youtube/search/) so the
// YouTube API key lives server-side instead of being inlined into the shipped
// JS bundle. The upstream response (with `items`) is passed through verbatim.
const youtubeSearch = (q) => `/api/v1/youtube/search/?q=${encodeURIComponent(q)}`;

export const youtubeApi = createApi({
  reducerPath: 'youtubeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
  }),
  endpoints: (builder) => ({
    searchTrailers: builder.query({
      query: ({ query, kind, year }) =>
        youtubeSearch(`${query} ${kind} ${year} trailer`),
      providesTags: ['searchTrailers'],
    }),
    searchEpisodePromos: builder.query({
      query: ({ query, seasonNumber, episodeNumber }) =>
        youtubeSearch(`${query} season ${seasonNumber} episode ${episodeNumber} trailer`),
      providesTags: ['searchEpisodePromos'],
    }),
  }),
});

export const { useLazySearchTrailersQuery, useLazySearchEpisodePromosQuery } = youtubeApi;
